module.exports = __webpack_public_path__ + "img/eraser.8d3f2c35.svg";